/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

/**
 * This component is used to switch form
 */
var $ = require('jquery');
var localize = require('./localize.service');
var networksService = require('./networks.service');
var paymentLayout = require('./payment-option-layout.service');

function switchForm(newCode, rootScope) {
    var networks = rootScope.getAllNetworks();
    var newNetwork = networksService.getNetworkByCode(networks, newCode);
    if (newNetwork && newNetwork.links && newNetwork.links.lang) {
        localize.load(newNetwork.links.lang, newFormLanguageCallBack, {
            newNetwork: newNetwork,
            rootScope: rootScope,
        });
    }
}

function newFormLanguageCallBack(err, data, bindingData) {
    if (err) {
        return err;
    }
    var oldNetWorkCode = bindingData.rootScope.getSelectedNetworkCode();
    // todo: theForm should be injected and specified in service cause it is different in iframe/selected native
    var theForm = $('#' + oldNetWorkCode + 'form');
    theForm.find('img[data-switch="true"]').each(function () {
        var oldSrc = $(this).attr('src');
        var arr = oldSrc.split('/');
        arr.splice(-2, 1, bindingData.newNetwork.networkCode);
        var newSrc = arr.join('/');
        $(this).attr('src', newSrc);
    });
    theForm.find('*[data-switch="true"]:not(img)').each(function () {
        var key = $(this).attr('data-translation-key');
        $(this).html(localize.translate(key, data));
    });
    theForm.attr('id', bindingData.newNetwork.networkCode + 'form');
    theForm
        .find('.verificationCode')
        .attr('specificplaceholder', localize.translate('account.verificationCode.specific.placeholder', data));
    paymentLayout.handleSmartSwitchForm(bindingData.newNetwork.networkCode, false);
}

module.exports = switchForm;
